<template><div></div></template>

<script>
export default {
  name: 'logout-page',
  mounted () {
    this.$store.dispatch('logout')
    this.$router.replace({name: 'Login',
      params: {msg: {message: 'You have been logged out. Thank you.', type: 'hide', color: 'success'}}})
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LogoutPage.vue